import { BACKEND_URL, JWT_KEY } from '../config';
import { getWithExpiry } from './localStorageService';

const getAuthHeader = () => ({
  'Content-Type': 'application/json',
  'Accept-Encoding': 'gzip',
  Authorization: `Bearer ${getWithExpiry(JWT_KEY)}`,
});

export const getAllStaffCategories = async () => {
  try {
    const response = await fetch(`${BACKEND_URL}api/v1/staffCategory`, {
      headers: getAuthHeader(),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('ERROR in getAllStaffCategories: ', errorText);
      return { errors: errorText };
    }

    const data = await response.json();
    console.log('RESULT (getAllStaffCategories): ', data);
    return { data };
  } catch (err) {
    console.error('Error getAllStaffCategories:', err);
    return { errors: err.message };
  }
};

export const getStaffCategoryById = async (staffCategoryId) => {
  try {
    const response = await fetch(
      `${BACKEND_URL}api/v1/staffCategory/${staffCategoryId}`,
      {
        headers: getAuthHeader(),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error('ERROR in getStaffCategoryById: ', errorText);
      return { errors: errorText };
    }

    const data = await response.json();
    console.log('RESULT (getStaffCategoryById): ', data);
    return { data };
  } catch (err) {
    console.error('Error getStaffCategoryById:', err);
    return { errors: err.message };
  }
};

export const addStaffCategory = async (category) => {
  try {
    const response = await fetch(
      `${BACKEND_URL}api/v1/staffCategory/admin`,
      {
        method: 'POST',
        mode: 'cors',
        headers: getAuthHeader(),
        body: JSON.stringify({ category }),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error('ERROR in addStaffCategory: ', errorText);
      return { errors: errorText };
    }

    const data = await response.json();
    console.log('RESULT (addStaffCategory): ', data);
    return { data };
  } catch (err) {
    console.error('Error addStaffCategory:', err);
    return { errors: err.message };
  }
};

export const updateStaffCategory = async (staffCategoryId, category) => {
  try {
    const response = await fetch(
      `${BACKEND_URL}api/v1/staffCategory/admin/${staffCategoryId}`,
      {
        method: 'PUT',
        mode: 'cors',
        headers: getAuthHeader(),
        body: JSON.stringify({ category }),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error('ERROR in updateStaffCategory: ', errorText);
      return { errors: errorText };
    }

    const data = await response.json();
    console.log('RESULT (updateStaffCategory): ', data);
    return { data };
  } catch (err) {
    console.error('Error updateStaffCategory:', err);
    return { errors: err.message };
  }
};

export const deleteStaffCategory = async (staffCategoryId) => {
  try {
    const response = await fetch(
      `${BACKEND_URL}api/v1/staffCategory/admin/${staffCategoryId}`,
      {
        method: 'DELETE',
        mode: 'cors',
        headers: getAuthHeader(),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error('ERROR in deleteStaffCategory: ', errorText);
      
      // Check for constraint violation (category is in use)
      try {
        const errorJson = JSON.parse(errorText);
        const errorMessage = errorJson.message || errorJson.error || '';
        
        if (errorMessage.toLowerCase().includes('constraint') || 
            errorMessage.toLowerCase().includes('still referenced') ||
            errorMessage.toLowerCase().includes('foreign key')) {
          return { errors: 'CONSTRAINT_VIOLATION' };
        }
      } catch (e) {
        // Error text is not JSON, continue with normal error handling
      }
      
      return { errors: errorText };
    }

    // Handle empty response body (common for DELETE operations)
    const text = await response.text();
    const data = text ? JSON.parse(text) : { success: true };
    console.log('RESULT (deleteStaffCategory): ', data);
    return { data };
  } catch (err) {
    console.error('Error deleteStaffCategory:', err);
    return { errors: err.message };
  }
};
